import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, ZapIcon, ThermometerIcon, HomeIcon, PaintbrushIcon, SparklesIcon, TreesIcon, BugIcon, ShowerHeadIcon, BathIcon, ArrowUpIcon, AppWindowIcon, SunIcon, CookingPotIcon, LayersIcon, DoorOpenIcon, WarehouseIcon, ShieldIcon, FenceIcon, SnowflakeIcon, FootprintsIcon } from 'lucide-react';
import { pxFormConfigs } from '../data/pxFormConfigs';
interface PopularServicesProps {
  onServiceClick?: (serviceSlug: string) => void;
}
export function PopularServices({
  onServiceClick
}: PopularServicesProps) {
  const allServices = [{
    name: 'Walk-In Showers',
    slug: 'walk-in-showers',
    icon: <ShowerHeadIcon className="w-6 h-6" data-id="element-2154" />,
    image: 'https://cdn.magicpatterns.com/uploads/rVvwQxykYfoPiNZvEbo3zW/Modern_spa_bathroom_with_walk-in_shower.png'
  }, {
    name: 'Walk-In Tubs',
    slug: 'walk-in-tubs',
    icon: <BathIcon className="w-6 h-6" data-id="element-2155" />,
    image: 'https://cdn.magicpatterns.com/uploads/uztf2XVa5Quyg5Kf3Z99xf/Contractor_installing_walk-in_tub_in_bathroom.png'
  }, {
    name: 'Stairlifts',
    slug: 'stairlifts',
    icon: <ArrowUpIcon className="w-6 h-6" data-id="element-2156" />,
    image: 'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Window Replacement',
    slug: 'window-replacement',
    icon: <AppWindowIcon className="w-6 h-6" data-id="element-2157" />,
    image: 'https://cdn.magicpatterns.com/uploads/enhxpbRYFup4NWmu52YvAC/ChatGPT_Image_Apr_8,_2026,_09_00_08_PM.png'
  }, {
    name: 'Gutter Guards',
    slug: 'gutter-guards',
    icon: <LayersIcon className="w-6 h-6" data-id="element-2158" />,
    image: 'https://cdn.magicpatterns.com/uploads/nHEsPtECKST1sy11QfZeZo/Roof_worker_installing_gutter_guard.png'
  }, {
    name: 'Roofing',
    slug: 'roofing',
    icon: <HomeIcon className="w-6 h-6" data-id="element-2159" />,
    image: 'https://cdn.magicpatterns.com/uploads/kq5KTHt4r49NEvb6baomEs/Roofing_project_in_progress_on_suburban_home.png'
  }, {
    name: 'Siding',
    slug: 'siding',
    icon: <HomeIcon className="w-6 h-6" data-id="element-2160" />,
    image: 'https://cdn.magicpatterns.com/uploads/e3vgaCMRMJVVB4ikxPQXtA/House_siding_installation_in_progress.png'
  }, {
    name: 'Solar Panels',
    slug: 'solar',
    icon: <SunIcon className="w-6 h-6" data-id="element-2161" />,
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Bathroom Remodel',
    slug: 'bathroom-remodel',
    icon: <ShowerHeadIcon className="w-6 h-6" data-id="element-2162" />,
    image: 'https://cdn.magicpatterns.com/uploads/7LG8d1xsN1EpGcbXWXtdPd/Bathroom_remodel_in_progress__.png'
  }, {
    name: 'Kitchen Remodel',
    slug: 'kitchen-remodel',
    icon: <CookingPotIcon className="w-6 h-6" data-id="element-2163" />,
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Flooring',
    slug: 'flooring',
    icon: <FootprintsIcon className="w-6 h-6" data-id="element-2164" />,
    image: 'https://cdn.magicpatterns.com/uploads/bBvVy9ZngdjBVioxvhvvbv/Home_renovation__installing_wood_flooring.png'
  }, {
    name: 'HVAC',
    slug: 'hvac',
    icon: <ThermometerIcon className="w-6 h-6" data-id="element-2165" />,
    image: 'https://cdn.magicpatterns.com/uploads/4LVZUr8iS1pjfVRpjj65dM/HVAC_technician_servicing_outdoor_unit.png'
  }, {
    name: 'Painting',
    slug: 'painting',
    icon: <PaintbrushIcon className="w-6 h-6" data-id="element-2166" />,
    image: 'https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Plumbing',
    slug: 'plumbing',
    icon: <WrenchIcon className="w-6 h-6" data-id="element-2167" />,
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Electrical',
    slug: 'electrical',
    icon: <ZapIcon className="w-6 h-6" data-id="element-2168" />,
    image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Fencing',
    slug: 'fencing',
    icon: <FenceIcon className="w-6 h-6" data-id="element-2169" />,
    image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Insulation',
    slug: 'insulation',
    icon: <SnowflakeIcon className="w-6 h-6" data-id="element-2170" />,
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Doors',
    slug: 'doors',
    icon: <DoorOpenIcon className="w-6 h-6" data-id="element-2171" />,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Garage Doors',
    slug: 'garage-doors',
    icon: <WarehouseIcon className="w-6 h-6" data-id="element-2172" />,
    image: 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Home Security',
    slug: 'home-security',
    icon: <ShieldIcon className="w-6 h-6" data-id="element-2173" />,
    image: 'https://cdn.magicpatterns.com/uploads/5Rf2g6s77D64RWVHLWz39v/Installing_a_home_security_camera.png'
  }, {
    name: 'Pest Control',
    slug: 'pest-control',
    icon: <BugIcon className="w-6 h-6" data-id="element-2174" />,
    image: 'https://images.unsplash.com/photo-1632483485005-1f5f1f5f1f5f?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Landscaping',
    slug: 'landscaping',
    icon: <TreesIcon className="w-6 h-6" data-id="element-2175" />,
    image: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Cleaning',
    slug: 'cleaning',
    icon: <SparklesIcon className="w-6 h-6" data-id="element-2176" />,
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'General Repair',
    slug: 'general',
    icon: <WrenchIcon className="w-6 h-6" data-id="element-2177" />,
    image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=800&q=80'
  }];
  // Separate services into active (has PX config or dedicated form) and coming soon
  const activeSlugs = ['walk-in-tubs', 'window-replacement', 'roofing', 'siding', 'hvac', 'bathroom-remodel', 'home-security', 'gutter-guards', 'flooring'];
  const activeServices = allServices.filter(s => activeSlugs.includes(s.slug));
  const comingSoonServices = allServices.filter(s => !activeSlugs.includes(s.slug));
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 10
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section id="services" className="py-20 bg-slate-50" data-id="element-2178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2179">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4" data-id="element-2180">
          <div data-id="element-2181">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-2182">
              Home Improvement Projects
            </h2>
            <p className="text-lg text-slate-600" data-id="element-2183">
              Browse our available service categories
            </p>
          </div>
        </div>

        <motion.div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-2184">
          {activeServices.map((service, index) => <motion.button key={index} variants={itemVariants} onClick={() => onServiceClick?.(service.slug)} className="group relative overflow-hidden rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-amber-200 hover:-translate-y-1 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 cursor-pointer h-48" data-id="element-2185">
              <img src={service.image} alt={service.name} className="absolute inset-0 w-full h-full object-cover" data-id="element-2186" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent" data-id="element-2187" />
              <div className="absolute inset-0 flex flex-col items-center justify-end p-4" data-id="element-2188">
                <h3 className="text-base font-bold text-white mb-2 text-center" data-id="element-2189">
                  {service.name}
                </h3>
                <span className="text-sm font-medium text-amber-400 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1" data-id="element-2190">
                  Get Quotes <span aria-hidden="true" data-id="element-2191">&rarr;</span>
                </span>
              </div>
            </motion.button>)}
        </motion.div>

        {comingSoonServices.length > 0 && <div className="mt-20" data-id="element-2192">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-2193">
              <div data-id="element-2194">
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-2195">
                  Coming Soon
                </h3>
                <p className="text-slate-500" data-id="element-2196">
                  We're working on adding more service categories to our network
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5 opacity-60 grayscale" data-id="element-2197">
              {comingSoonServices.map((service, index) => <div key={index} className="relative overflow-hidden rounded-xl border border-slate-200 cursor-not-allowed h-48" data-id="element-2198">
                  <img src={service.image} alt={service.name} className="absolute inset-0 w-full h-full object-cover" data-id="element-2199" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent" data-id="element-2200" />
                  <div className="absolute inset-0 flex flex-col items-center justify-end p-4" data-id="element-2201">
                    <h3 className="text-sm font-semibold text-white mb-2 text-center" data-id="element-2202">
                      {service.name}
                    </h3>
                    <span className="text-xs font-medium text-slate-300 uppercase tracking-wider" data-id="element-2203">
                      Coming Soon
                    </span>
                  </div>
                </div>)}
            </div>
          </div>}
      </div>
    </section>;
}